import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import LoadingModal from '../../components/common/LoadingModal';
import * as MeActionCreators from '../../redux/me';

const PageWrapper = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
`;
const LoginWrapper = styled.div`
  display: flex;
  position: relative;
  width: auto;
  height: auto;
  justify-content: center;
  flex-direction: column;
`;

const LoginHeader = styled.div`
  display: block;
  color: white;
  background-color: #2babf9;
  border-radius: 5px;
  width: auto;
  text-align: center;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: -40px;
  padding: 25px 0;
  margin-bottom: 15px;
`;

const LoginForm = styled.form`
  padding: 5px;
  border-radius: 5px;
  margin: 0;
  background-color: #ffffff;
`;

const LoginBody = styled.div`
  padding: 0.9375rem 1.875rem;
  width: auto;
  flex: 1 1 auto;
`;

const loginComponentStyle = {
  padding: '15px'
};

class LoginPage extends Component {
  state = {
    idField: null,
    passwordField: null,
    error: false
  };

  handleClose = () => {
    this.setState({ error: false });
  };

  render() {
    const { ui } = this.props;
    return (
      <PageWrapper>
        <LoginWrapper>
          <LoginForm>
            <LoginHeader>
              <h3>Login</h3>
            </LoginHeader>
            <LoginBody>
              <TextField
                id="id"
                label="Email or id ..."
                placeholder="Input your email or id ..."
                fullWidth
                margin="normal"
                style={loginComponentStyle}
                onChange={e => this.setState({ idField: e.target.value })}
              />
              <TextField
                id="password"
                label="Password"
                type="password"
                placeholder="Input your password ..."
                fullWidth
                margin="normal"
                style={loginComponentStyle}
                onChange={e => this.setState({ passwordField: e.target.value })}
              />
              <Button
                color="primary"
                fullWidth
                style={loginComponentStyle}
                onClick={async () => {
                  const { history } = this.props;
                  try {
                    const { actions } = this.props;
                    const { idField, passwordField } = this.state;
                    await actions.login({
                      login: idField,
                      password: passwordField
                    });
                    await actions.getMe();
                    history.push('/business-metrics');
                  } catch (error) {
                    this.setState({ error: true });
                  }
                }}
              >
                Login
              </Button>
            </LoginBody>
          </LoginForm>
        </LoginWrapper>
        <Dialog
          open={this.state.error}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Login fail</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Check your username, password.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        <LoadingModal open={ui === 'loading'} />
      </PageWrapper>
    );
  }
}

const mapStateToProps = state => ({
  ui: state.ui.uiState
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(MeActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginPage)
);



// WEBPACK FOOTER //
// ./src/pages/login/index.js